import React, { useEffect } from "react";
import { Container } from "./Section.styled";
import { useInView } from "react-intersection-observer";
import { usePageContextFunction } from "../../../context/PageContext";
import { useParams } from "react-router-dom";
import { func } from "../../../utils";
import useWindowSize from "../../../hooks/useWindowSize";

const Section = ({
  children,
  id,
  display,
  alignItems,
  height,
  scrollSnap,
  position,
  backgroundColor,
  background,
  overflowX,
  overflowY,
  padding,
  className,
}) => {
  const { city } = useParams();
  const { ref, inView } = useInView({
    threshold: 0,
  });

  const { size } = useWindowSize();
  const isMobileView = (size?.width || 0) <= 768;
  const bgPath = isMobileView ? "/bg/bg-mobile-talent.png" : "/bg/bg-talent.jpg";

  const { setIdInView, setActiveColor } = usePageContextFunction();
  useEffect(() => {
    if (id.includes("pertandingan") || id.includes("lokasi")) {
      return setActiveColor(`url(${func.getStaticImg(bgPath)})`);
    }
    //  else if (id.includes("lokasi")) {
    //   if (city === "soc") {
    //     return setActiveColor(`linear-gradient(
    //       to bottom,
    //       #274364 20%,
    //       #274364 50%)`);
    //   }
    // }
    else {
      //     return setActiveColor(`url(${func.getStaticImg("/bg/bg-talent.jpg")})`);
      return setActiveColor(`linear-gradient(
          to bottom,
          #fff 20%,
          #fff 50%)`);
    }

    setActiveColor("#fff");
  }, [id, bgPath]);

  useEffect(() => {
    if (inView) {
      setIdInView(id);
    }
  }, [inView, id]);

  return (
    <Container
      ref={ref}
      id={id}
      alignItems={alignItems}
      display={display}
      height={height}
      scrollSnap={scrollSnap}
      position={position}
      backgroundColor={backgroundColor}
      background={background}
      overflowX={overflowX}
      overflowY={overflowY}
      padding={padding}
      className={className}
    >
      {children}
    </Container>
  );
};

export default Section;
